import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, switchMap, takeUntil } from 'rxjs';
import { take } from 'rxjs/operators';

import {
    CloseSidebarOnlineOrder,
    CloseSidebarOnlineOrderDueNavigationError,
    CloseSidebarOnlineOrderDueNavigationSuccess,
    CloseSidebarOnlineOrderError,
    CloseSidebarOnlineOrderSuccess,
    OpenSidebarOnlineOrderSuccess,
    OpenSidebarOrderDetail,
} from './order-detail.actions';

import { SidebarPublicPort, SidebarPublicModels } from '@features/sidebar';
import { routerPublicEvents as routerEvents } from '@frontend/libs/duttirouter';
import { SidebarAdapter } from '@pages/my-account/sections/orders-type/infrastructure/features/sidebar/sidebar.adapter';

@Injectable()
export class OrderDetailEffects {
    private readonly actions$ = inject(Actions);

    private readonly store = inject(Store);

    public openSidebar$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(OpenSidebarOrderDetail),
            map(({ order, hasSubOrders }) => {
                SidebarPublicPort(this.store).openSidebarCustom({
                    component: SidebarPublicModels.sidebarCustomComponents.ORDER_DETAIL,
                    initializeFunction: undefined,
                    data: { order, hasSubOrders },
                });
            }),
            map(() => OpenSidebarOnlineOrderSuccess())
        );
    });

    public closeSidebar$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(CloseSidebarOnlineOrder),
            map((_) => {
                try {
                    SidebarAdapter.closeSidebar(this.store);
                } catch (error) {
                    return CloseSidebarOnlineOrderError({ error });
                }
                return CloseSidebarOnlineOrderSuccess();
            }),
        );
    });

    public closeSideBarOnNavigation$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(OpenSidebarOrderDetail),
            switchMap(() => this.actions$.pipe(
                ofType(routerEvents.PageChangedEvent),
                take(1),
                takeUntil(this.actions$.pipe(ofType(
                    CloseSidebarOnlineOrderError,
                    CloseSidebarOnlineOrderSuccess,
                    CloseSidebarOnlineOrderDueNavigationError,
                    CloseSidebarOnlineOrderDueNavigationSuccess,
                ))),
            )),
            map(() => {
                try {
                    SidebarAdapter.closeSidebar(this.store);
                } catch (error) {
                    return CloseSidebarOnlineOrderDueNavigationError({ error });
                }
                return CloseSidebarOnlineOrderDueNavigationSuccess();
            }),
        );
    });
}
